import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./ShowRoomBaghdadHero.css";

import { LanguageContext } from "../../context/LanguageContext";

const ShowRoomBaghdadHero = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadHero?lang=${currentLang}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed loading ShowRoomBaghdadHero:", err);
      }
    };

    load();
  }, [API_BASE, currentLang]);

  if (!data) {
    return (
      <div className="showRoomHero loading">
        <p style={{ color: "#fff", padding: "40px" }}>Loading...</p>
      </div>
    );
  }

  return (
    <div
      className="showRoomHero no-rtl"
      style={{
        backgroundImage: `url(${API_BASE + data.backgroundImage})`,
      }}
    >
      {/* ========= CONTENT (RIGHT SIDE) ========= */}
      <div className="sr-hero-content">
        <h1>{data.title}</h1>
      </div>

      {/* ========= SCROLL DOWN ========= */}
      <div
        className="scroll-down"
        onClick={() =>
          window.scrollTo({
            top: window.innerHeight,
            behavior: "smooth",
          })
        }
      >
        <span>Scroll down</span>
        <div className="arrow-down">↓</div>
      </div>
    </div>
  );
};

export default ShowRoomBaghdadHero;
